import { render } from "./EventsList.vue?vue&type=template&id=20db3676&scoped=true"
import script from "./EventsList.vue?vue&type=script&lang=js"
export * from "./EventsList.vue?vue&type=script&lang=js"

import "./EventsList.vue?vue&type=style&index=0&id=20db3676&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src953824513/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20db3676"]])

export default __exports__